import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BuyersRoutingModule } from './buyers-routing.module';
import { NavbarModule } from '../navbar/navbar.module';
import { ToolbarModule } from '../toolbar/toolbar.module';
import { TranslateModule } from '@ngx-translate/core';
import { LoadingModule } from '../loading/loading.module';
import { SharedModule } from '../shared/shared.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatRadioModule } from '@angular/material/radio';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatMenuModule } from '@angular/material/menu';

import { BuyersComponent } from './buyers/buyers.component';
import { BuyersDataComponent } from './buyers-data/buyers-data.component';
import { BuyersHeaderComponent } from './buyers-header/buyers-header.component';
import { BuyersSummaryComponent } from './buyers-summary/buyers-summary.component';
import { BuyersDataTableComponent } from './buyers-data-table/buyers-data-table.component';
import { BuyersDataEmptyComponent } from './buyers-data-empty/buyers-data-empty.component';
import { BuyersOnboardingDialogComponent } from './buyers-onboarding-dialog/buyers-onboarding-dialog.component';
import { BuyersFiltersComponent } from './buyers-filters/buyers-filters.component';
import { BuyersFilterDialogComponent } from './buyers-filter-dialog/buyers-filter-dialog.component';
import { BuyersEditDialogComponent } from './buyers-edit-dialog/buyers-edit-dialog.component';
import { BuyersRequestsDialogComponent } from './buyers-requests-dialog/buyers-requests-dialog.component';
import { BuyersEditCardDialogComponent } from './buyers-edit-card-dialog/buyers-edit-card-dialog.component';
import { BuyersEditIbanDialogComponent } from './buyers-edit-iban-dialog/buyers-edit-iban-dialog.component';
import { BuyersAccessControlDialogComponent } from './buyers-access-control-dialog/buyers-access-control-dialog.component';
import { BuyersSetBlockByAdminDialogComponent } from './buyers-set-block-by-admin-dialog/buyers-set-block-by-admin-dialog.component';
import { BuyersConfirmOtpDialogComponent } from './buyers-confirm-otp-dialog/buyers-confirm-otp-dialog.component';

@NgModule({
  declarations: [
    BuyersComponent,
    BuyersDataComponent,
    BuyersHeaderComponent,
    BuyersSummaryComponent,
    BuyersDataTableComponent,
    BuyersDataEmptyComponent,
    BuyersOnboardingDialogComponent,
    BuyersFiltersComponent,
    BuyersFilterDialogComponent,
    BuyersEditDialogComponent,
    BuyersRequestsDialogComponent,
    BuyersEditCardDialogComponent,
    BuyersEditIbanDialogComponent,
    BuyersAccessControlDialogComponent,
    BuyersSetBlockByAdminDialogComponent,
    BuyersConfirmOtpDialogComponent,
  ],
  imports: [
    CommonModule,
    BuyersRoutingModule,
    NavbarModule,
    ToolbarModule,
    TranslateModule,
    LoadingModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatTableModule,
    MatDatepickerModule,
    MatRadioModule,
    MatExpansionModule,
    MatSlideToggleModule,
    MatMenuModule,
  ],
})
export class BuyersModule {}
